import { render, staticRenderFns } from "./noZklistrtst.vue?vue&type=template&id=05bcf8a0&scoped=true&"
import script from "./noZklistrtst.vue?vue&type=script&lang=js&"
export * from "./noZklistrtst.vue?vue&type=script&lang=js&"
import style0 from "./noZklistrtst.vue?vue&type=style&index=0&id=05bcf8a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bcf8a0",
  null
  
)

export default component.exports